"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountUpgrade = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/components/site-menu/component");
const backendImport_1 = require("@front/backendImport");
const translations_1 = require("@front/application/globals/translations");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const console_1 = require("@rws-framework/console");
const WSService_audio_1 = __importStar(require("@front/services/WSService.audio"));
const backendImport_2 = require("@front/backendImport");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="account-upgrade-page">    
        <div ?hidden="${x => x.loading}">
            <div ?hidden="${x => !x.currentUser}">
                
                <div class="current-grade-section mb-4">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">${() => 'account.upgrade.currentGrade'.t()}</h5>
                            <div class="d-flex align-items-center">
                                <div class="current-grade-badge me-3 mr-3">
                                    <span class="badge badge-lg badge-primary">
                                        ${x => x.getGradeDisplayName(x.currentGrade)}
                                    </span>
                                </div>
                                <div>
                                    <p class="mb-0 text-muted">${x => x.getGradeDescription(x.currentGrade)}</p>
                                    <small class="text-success">${x => { var _a; return x.formatPrice(((_a = x.currentGrade) === null || _a === void 0 ? void 0 : _a.price) || 0); }}${(0, fast_element_1.when)(x => { var _a; return ((_a = x.currentGrade) === null || _a === void 0 ? void 0 : _a.price) > 0; }, (0, fast_element_1.html) `/month`)}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="grade-selection-section">
                    <h2 class="mb-3 text-center">${() => 'account.upgrade.selectGrade'.t()}</h2>
                    
                    
                    <div class="billing-period-toggle text-center mb-4">
                        <div class="btn-group" role="group">
                            <button type="button" 
                                class="btn ${x => x.billingPeriod === 'monthly' ? 'btn-primary' : 'btn-outline-primary'}"
                                @click="${x => x.toggleBillingPeriod('monthly')}">
                                ${'account.upgrade.monthly'.t()}
                            </button>
                            <button type="button" 
                                class="btn ${x => x.billingPeriod === 'yearly' ? 'btn-primary' : 'btn-outline-primary'}"
                                @click="${x => x.toggleBillingPeriod('yearly')}">
                                ${'account.upgrade.yearly'.t()}
                                <span class="badge badge-success ml-1">${'account.upgrade.saveMore'.t()}</span>
                            </button>
                        </div>
                    </div>
                    
                    <div ?hidden="${x => !x.gradesLoading}" class="text-center mb-4">
                        <app-loader></app-loader>
                        <p class="mt-2">${() => 'account.upgrade.loadingGrades'.t()}</p>
                    </div>
                    
                    <div ?hidden="${x => x.gradesLoading}" id="gradeSelectionGrid" class="row justify-content-center">
                        ${(0, fast_element_1.repeat)(x => x.availableGrades, (0, fast_element_1.html) `
                            <div class="col-lg-6 col-md-6 mb-4">
                                <div class="card grade-card h-100 ${(grade, c) => c.parent.isSelectedGrade(grade) ? 'selected' : ''}${(grade, c) => c.parent.isFutureGrade(grade) ? ' future' : ''}" @click="${(grade, c) => { c.event.preventDefault(); c.parent.handleGradeClick(grade); }}">
                                    ${(0, fast_element_1.when)(grade => grade.price > 0 && grade.name.toLowerCase().includes('pro'), (0, fast_element_1.html) `
                                        <div class="popular-badge">
                                            <span class="badge badge-warning">${() => 'account.upgrade.mostPopular'.t()}</span>
                                        </div>
                                    `)}
                                    <div class="card-body text-center">
                                        ${(0, fast_element_1.when)(x => x.icon, (0, fast_element_1.html) `<div class="grade-icon mb-3">
                                            <i class="${x => x.icon}"></i>
                                        </div>`)}
                                        <h5 class="grade-name">${(grade, c) => c.parent.getGradeDisplayName(grade)}</h5>
                                        <p class="grade-description text-muted">${(grade, c) => c.parent.getGradeDescription(grade)}</p>
                                        
                                        <div class="grade-price mb-3">
                                            ${(0, fast_element_1.when)((grade, c) => c.parent.billingPeriod === 'monthly', (0, fast_element_1.html) `
                                                <span class="price">${(grade, c) => c.parent.formatPrice(grade.price)}</span>
                                                ${(0, fast_element_1.when)(x => x.price > 0, (0, fast_element_1.html) `<small class="text-muted">/month</small>`)}
                                            `)}
                                            ${(0, fast_element_1.when)((grade, c) => c.parent.billingPeriod === 'yearly', (0, fast_element_1.html) `
                                                <div class="yearly-pricing">
                                                    <span class="price">${(grade, c) => c.parent.formatPrice(grade.yearlyPrice || (grade.price * 12))}</span>
                                                    ${(0, fast_element_1.when)(x => x.price > 0, (0, fast_element_1.html) `<small class="text-muted">/year</small>`)}
                                                    ${(0, fast_element_1.when)((grade, c) => c.parent.hasYearlyPricing(grade), (0, fast_element_1.html) `
                                                        <div class="discount-info mt-1">
                                                            <small class="text-success">
                                                                <strong>${(grade, c) => c.parent.getYearlyDiscount(grade).percentage}% ${'account.upgrade.discount'.t()}</strong>
                                                                (${'account.upgrade.save_money_amount'.t()} ${(grade, c) => c.parent.formatPrice(c.parent.getYearlyDiscount(grade).amount)})
                                                            </small>
                                                            <div class="original-price">
                                                                <small class="text-muted text-decoration-line-through">
                                                                    ${(grade, c) => c.parent.formatPrice(grade.price * 12)}/year
                                                                </small>
                                                            </div>
                                                        </div>
                                                    `)}
                                                </div>
                                            `)}
                                            ${(0, fast_element_1.when)(x => x.creditsPerMonth > 0, (0, fast_element_1.html) `
                                                <div class="credits-info mt-2">
                                                    <small class="text-info">
                                                        <i class="simple-icon-energy me-1"></i>
                                                        ${(grade, c) => c.parent.formatCredits(grade.creditsPerMonth)} ${'account.upgrade.perMonth'.t()}
                                                    </small>
                                                </div>
                                            `)}
                                        </div>
                                        
                                        
                                        <div class="grade-features mb-3">
                                            <h6 class="text-muted mb-2">${() => 'accountGrade.features'.t()}</h6>
                                            <ul class="list-unstyled">
                                                ${(0, fast_element_1.repeat)((grade, c) => c.parent.getGradeFeatures(grade), (0, fast_element_1.html) `
                                                    <li class="mb-1"><i class="simple-icon-check text-success me-2"></i> ${feature => feature}</li>
                                                `)}
                                            </ul>
                                        </div>
                                        
                                        
                                        <div class="grade-limits mb-4">
                                            <h6 class="text-muted mb-2">${() => 'accountGrade.limits'.t()}</h6>
                                            <div class="limits-grid">
                                                ${(0, fast_element_1.repeat)((grade, c) => c.parent.getGradeLimits(grade), (0, fast_element_1.html) `
                                                    <div class="d-flex justify-content-between align-items-center mb-1">
                                                        <small class="text-muted">${limit => limit.label}</small>
                                                        <span class="badge ${(limit, c) => limit.value === null ? 'badge-success' : 'badge-info'} badge-sm">
                                                            ${(limit, c) => c.parentContext.parent.formatLimitValue(limit.value)}
                                                        </span>
                                                    </div>
                                                `)}
                                            </div>
                                        </div>
                                        
                                        ${(0, fast_element_1.when)((grade, c) => c.parent.isFutureGrade(grade), (0, fast_element_1.html) `<p class="future-info">                                            
                                            ${'account.upgrade.futureGradeInfo'.t()}: <strong>${(x, c) => c.parent.formatFutureDate()}</strong>
                                        </p>`, (0, fast_element_1.html) `<button class="btn grade-select-btn w-100"                                                 
                                                @click="${(grade, c) => { c.event.stopPropagation(); c.event.preventDefault(); c.parent.handleGradeClick(grade); }}">
                                            ${(grade, c) => c.parent.isSelectedGrade(grade) ? 'account.upgrade.selected'.t() : 'account.upgrade.selectPlan'.t()}
                                        </button>`)}
                                    </div>
                                </div>
                            </div>
                        `)}
                    </div>

                    
                    <div class="action-buttons mt-4 text-center" ?hidden="${x => x.gradesLoading}">
                        <button
                                class="btn btn-lg ${x => { var _a; return ((_a = x.selectedGrade) === null || _a === void 0 ? void 0 : _a.price) === 0 || x.isDowngrade() ? 'btn-warning' : 'btn-success'; }}"
                                @click="${x => x.upgradeAccount()}" 
                                ?disabled="${x => x.loading || !x.selectedGrade || x.isCurrentGrade(x.selectedGrade)}">
                            <i class="${x => { var _a; return ((_a = x.selectedGrade) === null || _a === void 0 ? void 0 : _a.price) === 0 || x.isDowngrade() ? 'simple-icon-minus' : 'simple-icon-credit-card'; }} me-2"></i>
                            ${x => x.getActionButtonText()}
                        </button>
                    </div>
                </div>
            </div>

            <div class="text-center mt-5" ?hidden="${x => x.currentUser}">
                <p class="text-muted">${() => 'account.upgrade.errors.noUser'.t()}</p>
            </div>
        </div>

        <div class="text-center" ?hidden="${x => !x.loading}">
            <app-loader></app-loader>
            <p class="mt-3">${() => 'common.loading'.t()}</p>
        </div>
    </div>
</div>
${(0, fast_element_1.when)(x => x.paymentStarted && x.selectedGrade, (0, fast_element_1.html) `<rws-modal :closeModal="${x => x.closeGateway.bind(x)}"><payment-gateway 
    paymentName="account.upgrade"
    :accountGrade="${x => x.selectedGrade}"
    :billingPeriod="${x => x.billingPeriod}"
    @payment-success="${(x, c) => x.handlePaymentSuccess(c.event)}"
    @payment-error="${(x, c) => x.handlePaymentError(c.event)}"
    @payment-failed="${(x, c) => x.handlePaymentError(c.event)}"
    >
</payment-gateway></rws-modal>`)}`;
require("./styles/layout.scss");
const styles = T.css `#gradeSelectionGrid {
  width: 70%;
  margin: auto;
}

.account-upgrade-page {
  padding: 1rem;
}
.account-upgrade-page h1 {
  font-size: 2.5rem;
  font-weight: 700;
}
.account-upgrade-page h5 {
  font-size: 1.4rem;
  font-weight: 600;
}
.account-upgrade-page p {
  font-size: 1.1rem;
}
.account-upgrade-page small {
  font-size: 1rem;
}
.account-upgrade-page .current-grade-section .card {
  background: linear-gradient(135deg, var(--primary-color), var(--alt_blu));
  border: none;
  color: white;
}
.account-upgrade-page .current-grade-section .card .card-title {
  color: white;
  font-weight: 600;
  font-size: 1.5rem;
}
.account-upgrade-page .current-grade-section .card .current-grade-badge .badge {
  font-size: 1.25rem;
  padding: 0.75rem 1.25rem;
}
.account-upgrade-page .current-grade-section .card .badge-free {
  background: #6c757d;
}
.account-upgrade-page .current-grade-section .card .badge-basic {
  background: #28a745;
}
.account-upgrade-page .current-grade-section .card .badge-pro {
  background: #ffc107;
  color: #000;
}
.account-upgrade-page .current-grade-section .card .badge-ultra {
  background: #dc3545;
}
.account-upgrade-page .grade-card {
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.account-upgrade-page .grade-card .card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.account-upgrade-page .grade-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border-color: var(--primary-color);
}
.account-upgrade-page .grade-card.selected {
  border: 3px solid var(--primary-color);
  box-shadow: 0 10px 30px rgba(115, 35, 107, 0.4), 0 0 0 1px var(--primary-color);
  transform: translateY(-5px);
}
.account-upgrade-page .grade-card.selected .card-body {
  background: linear-gradient(135deg, rgba(115, 35, 107, 0.08), rgba(69, 86, 172, 0.08));
}
.account-upgrade-page .grade-card.future {
  border: 3px solid var(--warning-color);
  transform: translateY(-5px);
}
.account-upgrade-page .grade-card.future .card-body {
  background: linear-gradient(135deg, rgba(115, 35, 107, 0.08), rgba(69, 86, 172, 0.08));
}
.account-upgrade-page .grade-card.popular {
  border-color: var(--alt_blu);
}
.account-upgrade-page .grade-card.popular:hover {
  border-color: var(--alt_blu);
  box-shadow: 0 10px 30px rgba(69, 86, 172, 0.3);
}
.account-upgrade-page .grade-card .popular-badge {
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 10;
}
.account-upgrade-page .grade-card .popular-badge .badge {
  border-radius: 0 0.375rem 0 0.5rem;
  padding: 0.75rem 1.25rem;
  font-size: 0.9rem;
}
.account-upgrade-page .grade-card .future-info {
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--warning-color);
}
.account-upgrade-page .grade-card .grade-icon {
  font-size: 3rem;
  color: var(--primary-color);
}
.account-upgrade-page .grade-card .grade-name {
  color: var(--primary-color);
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
}
.account-upgrade-page .grade-card .grade-description {
  font-size: 1.1rem;
  line-height: 1.4;
}
.account-upgrade-page .grade-card .grade-price .price {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--primary-color);
}
.account-upgrade-page .grade-card .grade-price small {
  font-size: 1rem;
}
.account-upgrade-page .grade-card .grade-features h6 {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 0.75rem;
}
.account-upgrade-page .grade-card .grade-features li {
  padding: 0.25rem 0;
  font-size: 1rem;
}
.account-upgrade-page .grade-card .grade-features li i {
  width: 16px;
}
.account-upgrade-page .grade-card .grade-limits h6 {
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 0.75rem;
}
.account-upgrade-page .grade-card .grade-limits .limits-grid {
  font-size: 1rem;
}
.account-upgrade-page .grade-card .grade-limits .limits-grid .badge-sm {
  font-size: 0.85rem;
  padding: 0.35rem 0.65rem;
}
.account-upgrade-page .grade-card .grade-select-btn {
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 0.75rem 1rem;
  margin-top: auto;
}
.account-upgrade-page .grade-card .grade-select-btn.btn-primary {
  background: var(--primary-color);
  border-color: var(--primary-color);
}
.account-upgrade-page .grade-card .grade-select-btn.btn-primary:hover {
  background: var(--alt_blu);
  border-color: var(--alt_blu);
  transform: translateY(-2px);
}
.account-upgrade-page .grade-card .grade-select-btn.btn-outline-primary {
  color: var(--primary-color);
  border-color: var(--primary-color);
}
.account-upgrade-page .grade-card .grade-select-btn.btn-outline-primary:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
  transform: translateY(-2px);
}
.account-upgrade-page .popular .grade-icon {
  color: var(--alt_blu);
}
.account-upgrade-page .billing-period-toggle .btn-group .btn {
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
}
.account-upgrade-page .billing-period-toggle .btn-group .btn:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.account-upgrade-page .billing-period-toggle .btn-group .btn:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.account-upgrade-page .billing-period-toggle .btn-group .btn:last-child .badge {
  font-size: 0.75rem;
  background: #28a745 !important;
  color: white;
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 10px;
}
.account-upgrade-page .grade-price .yearly-pricing .discount-info .text-success {
  font-weight: 600;
  font-size: 0.9rem;
}
.account-upgrade-page .grade-price .yearly-pricing .discount-info .original-price {
  font-size: 0.8rem;
}
.account-upgrade-page .grade-price .yearly-pricing .discount-info .original-price .text-decoration-line-through {
  text-decoration: line-through;
}
.account-upgrade-page .action-buttons .btn {
  min-width: 200px;
  font-weight: 600;
  font-size: 1.25rem;
  padding: 1rem 2rem;
}
.account-upgrade-page .action-buttons .btn.btn-success {
  background: var(--primary-color);
  border-color: var(--primary-color);
}
.account-upgrade-page .action-buttons .btn.btn-success:hover {
  background: var(--alt_blu);
  border-color: var(--alt_blu);
  transform: translateY(-2px);
}
.account-upgrade-page .action-buttons .btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 991.98px) {
  .account-upgrade-page .grade-card {
    margin-bottom: 1.5rem;
  }
}
@media (max-width: 575.98px) {
  .account-upgrade-page .grade-card .grade-icon {
    font-size: 2rem;
  }
  .account-upgrade-page .grade-card .grade-price .price {
    font-size: 1.5rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let AccountUpgrade = class AccountUpgrade extends client_1.RWSViewComponent {
    constructor(popupService, wsService) {
        super();
        this.popupService = popupService;
        this.wsService = wsService;
        this.currentUser = null;
        this.selectedGrade = null;
        this.availableGrades = [];
        this.loading = false;
        this.gradesLoading = false;
        this.paymentStarted = false;
        this.currentGrade = null;
        this.billingPeriod = 'monthly';
        this.statusListenerCallBacks = [];
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        await this.loadAccountGrades();
        await this.loadCurrentUser();
        // Set up websocket listener for upgrade notifications
        this.setupUpgradeListener();
        // Set default selection to free grade or user's current grade
        if (this.availableGrades.length > 0) {
            const freeGrade = this.availableGrades.find(g => g.price === 0);
            if (!this.currentUser.accountGrade) {
                this.currentGrade = freeGrade;
            }
            this.selectedGrade = ((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.accountGrade) || freeGrade || this.availableGrades[0];
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Cleanup websocket listeners
        for (const cb of this.statusListenerCallBacks) {
            if (cb) {
                cb();
            }
        }
        this.statusListenerCallBacks = [];
    }
    /**
     * Set up websocket listener for upgrade notifications
     */
    setupUpgradeListener() {
        if (this.wsService.isActive()) {
            this.statusListenerCallBacks.push(this.wsService.listenForMessage('account_balance_update', (response) => {
                try {
                    const data = response.data.msg;
                    // Handle account upgrade notification
                    if (data.status === backendImport_2.ACCOUNT_BALANCE_EVENTS.ACCOUNT_UPGRADED) {
                        // Reload user data to reflect the upgrade
                        this.loadCurrentUser();
                        // Show success notification
                        this.notifyService.notify('account.upgrade.success.upgraded'.t(), 'info');
                        // Close any open payment modals
                        this.closeGateway();
                    }
                }
                catch (error) {
                    console.error('Error handling upgrade notification:', error);
                }
            }));
        }
    }
    async loadCurrentUser() {
        try {
            const response = await this.apiService.back.get('user.logged');
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.currentUser = response.data;
                if (this.currentUser.accountGrade) {
                    this.currentGrade = this.currentUser.accountGrade;
                }
                console.log('User loaded:', response.data);
            }
        }
        catch (error) {
            console.error('Failed to load current user:', error);
            this.notifyService.notify('account.upgrade.errors.loadUser'.t(), 'error');
        }
    }
    async loadAccountGrades() {
        this.gradesLoading = true;
        try {
            const response = await this.apiService.back.get('accountGrade.list');
            if ((response === null || response === void 0 ? void 0 : response.success) && Array.isArray(response.data)) {
                // Filter only active grades and sort by order/price
                this.availableGrades = response.data
                    .filter(grade => grade.active)
                    .sort((a, b) => {
                    if (a.order !== undefined && b.order !== undefined) {
                        return a.order - b.order;
                    }
                    return (a.price || 0) - (b.price || 0);
                });
                console.log('Account grades loaded:', this.availableGrades);
            }
            else {
                console.error('Failed to load account grades:', response === null || response === void 0 ? void 0 : response.error);
                this.notifyService.notify('account.upgrade.errors.loadGrades'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to load account grades:', error);
            this.notifyService.notify('account.upgrade.errors.loadGrades'.t(), 'error');
        }
        finally {
            this.gradesLoading = false;
        }
    }
    async upgradeAccount() {
        if (!this.currentUser || this.loading || !this.selectedGrade)
            return;
        // Handle downgrade or plan change
        if (this.selectedGrade.price === 0 || this.isDowngrade()) {
            await this.handleDowngrade();
            return;
        }
        this.paymentStarted = true;
    }
    async handleDowngrade() {
        var _a;
        if (!this.selectedGrade || !this.currentUser)
            return;
        const isDowngrade = this.selectedGrade.price === 0;
        const isChange = !isDowngrade && this.selectedGrade.price !== (((_a = this.currentUser.accountGrade) === null || _a === void 0 ? void 0 : _a.price) || 0);
        let confirmMessage = '';
        if (isDowngrade) {
            confirmMessage = 'account.upgrade.confirm.downgrade'.t();
        }
        else if (isChange) {
            confirmMessage = 'account.upgrade.confirm.change'.t() + ' ' + this.formatPrice(this.selectedGrade.price) + '/month?';
        }
        else {
            return; // No change needed
        }
        const confirmed = await this.popupService.confirm(confirmMessage, false, 'account.upgrade.confirm.title'.t());
        if (!confirmed) {
            return;
        }
        await this.processDowngrade();
    }
    async processDowngrade() {
        var _a;
        if (!this.selectedGrade || !this.currentUser)
            return;
        this.loading = true;
        try {
            const response = await this.apiService.back.post('payment.downgrade', {
                targetAccountGradeId: this.selectedGrade.id
            });
            if (response === null || response === void 0 ? void 0 : response.success) {
                this.notifyService.notify(((_a = response.data) === null || _a === void 0 ? void 0 : _a.message) || 'account.upgrade.success.changed'.t(), 'info');
                // Reload user data
                await this.loadCurrentUser();
                // Redirect after short delay
                setTimeout(() => {
                    component_1.SiteMenu.goto.bind(this)('/user/profile');
                }, 2000);
            }
            else {
                console.error('Downgrade failed:', response === null || response === void 0 ? void 0 : response.error);
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'account.upgrade.errors.changeFailed'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Downgrade error:', error);
            this.notifyService.notify('account.upgrade.errors.changeFailed'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    handleGradeClick(grade) {
        var _a;
        this.selectedGrade = grade;
        console.log('Grade clicked:', {
            clickedGrade: grade,
            newSelectedGrade: this.selectedGrade,
            currentUserGrade: (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.accountGrade
        });
    }
    handleGradeSelection(event) {
        const target = event.target;
        const gradeId = target.value;
        this.selectedGrade = this.availableGrades.find(g => g.id === gradeId) || null;
    }
    toggleBillingPeriod(period) {
        this.billingPeriod = period;
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/user/profile');
    }
    getGradeDisplayName(grade) {
        return (grade === null || grade === void 0 ? void 0 : grade.name) || 'Unknown Grade';
    }
    getGradeDescription(grade) {
        return (grade === null || grade === void 0 ? void 0 : grade.description) || '';
    }
    formatPrice(price, isYearly = false) {
        if (price === 0)
            return 'Free';
        const displayPrice = isYearly ? price : price;
        return `${(0, translations_1.getLanguage)() === 'en' ? '$' : ''}${displayPrice.currencyConvert('usd').toFixed(2)}${(0, translations_1.getLanguage)() !== 'en' ? (' ' + 'usd'.currency().toUpperCase()) : ''}`;
    }
    getCurrentPrice(grade) {
        if (this.billingPeriod === 'yearly') {
            return grade.yearlyPrice || (grade.price * 12);
        }
        return grade.price;
    }
    getYearlyDiscount(grade) {
        if (!grade.yearlyPrice || grade.price === 0) {
            return { percentage: 0, amount: 0 };
        }
        const monthlyTotal = grade.price * 12;
        const yearlyPrice = grade.yearlyPrice;
        const discount = monthlyTotal - yearlyPrice;
        const percentage = Math.round((discount / monthlyTotal) * 100);
        return { percentage, amount: discount };
    }
    hasYearlyPricing(grade) {
        return !!(grade.yearlyPrice && grade.yearlyPrice > 0 && grade.price > 0);
    }
    formatCredits(credits) {
        if (credits === 0)
            return 'account.upgrade.noCredits'.t();
        return `${credits.toLocaleString()} ${'account.upgrade.credits'.t()}`;
    }
    getGradeFeatures(grade) {
        const features = [];
        // Boolean features
        if (grade.advancedPrompts)
            features.push('accountGrade.advancedPrompts'.t());
        if (grade.promptAssist)
            features.push('accountGrade.promptAssist'.t());
        if (grade.antiHallucination)
            features.push('accountGrade.antiHallucination'.t());
        if (grade.advancedReports)
            features.push('accountGrade.advancedReports'.t());
        if (grade.chatThreadSharing)
            features.push('accountGrade.chatThreadSharing'.t());
        if (grade.customBranding)
            features.push('accountGrade.customBranding'.t());
        if (grade.widgets)
            features.push('accountGrade.widgets'.t());
        if (grade.voiceAgent)
            features.push('accountGrade.voiceAgent'.t());
        if (grade.writingStyles)
            features.push('accountGrade.writingStyles'.t());
        return features.slice(0, 6); // Show top 6 features
    }
    getGradeLimits(grade) {
        return [
            { key: 'maxUsers', value: grade.maxUsers, label: 'accountGrade.maxUsers'.t() },
            { key: 'maxAvatars', value: grade.maxAvatars, label: 'accountGrade.maxAvatars'.t() },
            { key: 'maxProjectsCount', value: grade.maxProjectsCount, label: 'accountGrade.maxProjectsCount'.t() },
            { key: 'maxKnowledgeEntries', value: grade.maxKnowledgeEntries, label: 'accountGrade.maxKnowledgeEntries'.t() },
            { key: 'customAiModels', value: grade.customAiModels, label: 'accountGrade.customAiModels'.t() }
        ].filter(limit => limit.value !== null || grade.price > 0); // Show limits for paid plans or when they have actual limits
    }
    formatLimitValue(value) {
        if (value === null)
            return 'accountGrade.unlimited'.t();
        return value.toString();
    }
    formatFutureDate() {
        var _a, _b;
        if (!((_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.onNextSubscriptionIteration) === null || _b === void 0 ? void 0 : _b.cancellationRequestedAt))
            return '';
        const date = console_1.DateUtils.create(this.currentUser.onNextSubscriptionIteration.cancellationRequestedAt);
        return date.formatDate('MMMM yyyy');
    }
    isCurrentGrade(grade) {
        var _a;
        if (!((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.accountGrade) || !grade)
            return false;
        return this.currentUser.accountGrade.id === grade.id;
    }
    isSelectedGrade(grade) {
        if (!this.selectedGrade || !grade)
            return false;
        return this.selectedGrade.id === grade.id;
    }
    isFutureGrade(grade) {
        var _a, _b;
        if (!((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.onNextSubscriptionIteration) || !grade)
            return false;
        return grade.id === ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.onNextSubscriptionIteration.newGradeId);
    }
    isDowngrade() {
        var _a;
        if (!this.selectedGrade || !((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.accountGrade))
            return false;
        const currentPrice = this.getCurrentPrice(this.currentUser.accountGrade);
        const selectedPrice = this.getCurrentPrice(this.selectedGrade);
        return selectedPrice < currentPrice;
    }
    isPlanChange() {
        var _a;
        if (!this.selectedGrade || !((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.accountGrade))
            return false;
        return this.selectedGrade.id !== this.currentUser.accountGrade.id;
    }
    getActionButtonText() {
        if (!this.selectedGrade)
            return 'account.upgrade.selectPlan'.t();
        if (this.isCurrentGrade(this.selectedGrade))
            return 'account.upgrade.currentPlan'.t();
        if (this.getCurrentPrice(this.selectedGrade) === 0)
            return 'account.upgrade.downgrade'.t();
        if (this.isDowngrade())
            return 'account.upgrade.downgrade'.t();
        if (this.isPlanChange())
            return 'account.upgrade.changePlan'.t();
        return 'account.upgrade.payNow'.t();
    }
    async handlePaymentSuccess(event) {
        console.log('Payment successful:', event.detail);
        // Close payment gateway
        this.closeGateway();
        // Show success notification
        this.notifyService.notify('account.upgrade.success.upgraded'.t(), 'info');
        // Reload user data to reflect the upgrade
        await this.loadCurrentUser();
        // Redirect to profile page after a short delay
        setTimeout(() => {
            component_1.SiteMenu.goto.bind(this)('/user/profile');
        }, 2000);
    }
    handlePaymentError(event) {
        console.error('Payment failed:', event.detail);
        this.notifyService.notify('account.upgrade.errors.paymentFailed'.t(), 'error');
    }
    closeGateway() {
        const stripeForm = document.body.querySelector('#stripe-form');
        if (stripeForm) {
            stripeForm.remove();
        }
        this.paymentStarted = false;
        const paymentGateway = this.shadowRoot.querySelector('payment-gateway');
        if (paymentGateway) {
            paymentGateway.hideGatewayElements = false;
        }
    }
};
exports.AccountUpgrade = AccountUpgrade;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IUser !== "undefined" && backendImport_1.IUser) === "function" ? _c : Object)
], AccountUpgrade.prototype, "currentUser", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.IAccountGrade !== "undefined" && backendImport_1.IAccountGrade) === "function" ? _d : Object)
], AccountUpgrade.prototype, "selectedGrade", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccountUpgrade.prototype, "availableGrades", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AccountUpgrade.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AccountUpgrade.prototype, "gradesLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], AccountUpgrade.prototype, "paymentStarted", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof backendImport_1.IAccountGrade !== "undefined" && backendImport_1.IAccountGrade) === "function" ? _e : Object)
], AccountUpgrade.prototype, "currentGrade", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], AccountUpgrade.prototype, "billingPeriod", void 0);
exports.AccountUpgrade = AccountUpgrade = __decorate([
    (0, client_1.RWSView)('account-upgrade', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(WSService_audio_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WSService_audio_1.WSServiceAudioInstance !== "undefined" && WSService_audio_1.WSServiceAudioInstance) === "function" ? _b : Object])
], AccountUpgrade);
AccountUpgrade.defineComponent();
